<template>
  <div>
    <AppNavbar v-if="shouldShowNavbar" class="no-print" />
    <div class="app-wrapper">
      <SideBar class="no-print"></SideBar>
      <div class="app-content">
        <main
          :class="{
            'certificate-page': $route.name === 'buildingCertificate',
          }"
        >
          <router-view></router-view>
        </main>
      </div>
    </div>
    <!-- <AppFooter /> -->
    <InstantNotification class="no-print"></InstantNotification>
  </div>
</template>

<script>
import AppNavbar from "./components/AppNavbar.vue";
import AppFooter from "./components/AppFooter.vue";
import InstantNotification from "./components/InstatntNotification.vue";
import SideBar from "./components/sidebar/Sidebar.vue";
import { MOBILE_UI_CONFIG } from "@/config/mobile-ui";
export default {
  data: () => {
    return {};
  },
  computed: {
    shouldShowNavbar() {
      const isMobileApp = this.$store.getters["user/isMobileApp"];
      if (!isMobileApp) {
        return true;
      }
      return MOBILE_UI_CONFIG.showNavbarOnMobile;
    },
  },
  components: {
    AppNavbar,
    AppFooter,
    InstantNotification,
    SideBar,
  },
};
</script>

<style scoped>
@media print {
  .no-print {
    display: none !important;
  }

  .app-wrapper {
    display: block !important;
  }

  .app-content {
    margin: 0 !important;
    padding: 0 !important;
    width: 100% !important;
  }
}
</style>
